import SearchTeaser from './index'
export default {
  SearchTeaser,
}
